import { render, staticRenderFns } from "./SoldSeatDialog.vue?vue&type=template&id=23cae5b2&"
import script from "./SoldSeatDialog.vue?vue&type=script&lang=js&"
export * from "./SoldSeatDialog.vue?vue&type=script&lang=js&"
import style0 from "./SoldSeatDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports